import folderSVG from '@plone/volto/icons/folder.svg';
import gridSVG from '@plone/volto/icons/grid.svg';
import homeBannerSVG from '@plone/volto/icons/image-wide.svg';
import imagesSVG from '@plone/volto/icons/images.svg';
import listBulletSVG from '@plone/volto/icons/list-bullet.svg';
import shareSVG from '@plone/volto/icons/share.svg';
import sliderSVG from '@plone/volto/icons/slider.svg';

import MpfAcoesRapidasBlockEdit from 'volto-ministerio-publico-federal/components/Blocks/AcoesRapidas/Edit';
import MpfAcoesRapidasBlockView from 'volto-ministerio-publico-federal/components/Blocks/AcoesRapidas/View';
import { AcoesRapidasBlockDataAdapter } from 'volto-ministerio-publico-federal/components/Blocks/AcoesRapidas/adapter';
import MpfAcompanheRedesBlockEdit from 'volto-ministerio-publico-federal/components/Blocks/AcompanheRedes/Edit';
import MpfAcompanheRedesBlockView from 'volto-ministerio-publico-federal/components/Blocks/AcompanheRedes/View';
import { mpfAcompanheRedesSchema } from 'volto-ministerio-publico-federal/components/Blocks/AcompanheRedes/schema';
import MpfDestaquesBlockEdit from 'volto-ministerio-publico-federal/components/Blocks/Destaques/Edit';
import MpfDestaquesBlockView from 'volto-ministerio-publico-federal/components/Blocks/Destaques/View';
import { DestaquesBlockDataAdapter } from 'volto-ministerio-publico-federal/components/Blocks/Destaques/adapter';
import MpfDestaquesCarrosselBlockEdit from 'volto-ministerio-publico-federal/components/Blocks/DestaquesCarrossel/Edit';
import MpfDestaquesCarrosselBlockView from 'volto-ministerio-publico-federal/components/Blocks/DestaquesCarrossel/View';
import { DestaquesCarrosselBlockDataAdapter } from 'volto-ministerio-publico-federal/components/Blocks/DestaquesCarrossel/adapter';
import HomeBannerBlockEdit from 'volto-ministerio-publico-federal/components/Blocks/HomeBanner/Edit';
import HomeBannerBlockView from 'volto-ministerio-publico-federal/components/Blocks/HomeBanner/View';
import { HomeBannerBlockDataAdapter } from 'volto-ministerio-publico-federal/components/Blocks/HomeBanner/adapter';
import MpfIniciativasBlockEdit from 'volto-ministerio-publico-federal/components/Blocks/Iniciativas/Edit';
import MpfIniciativasBlockView from 'volto-ministerio-publico-federal/components/Blocks/Iniciativas/View';
import { IniciativasBlockDataAdapter } from 'volto-ministerio-publico-federal/components/Blocks/Iniciativas/adapter';
import MpfOndeAtuaBlockEdit from 'volto-ministerio-publico-federal/components/Blocks/OndeAtua/Edit';
import MpfOndeAtuaBlockView from 'volto-ministerio-publico-federal/components/Blocks/OndeAtua/View';
import { OndeAtuaBlockDataAdapter } from 'volto-ministerio-publico-federal/components/Blocks/OndeAtua/adapter';
import { PollIcon } from 'volto-ministerio-publico-federal/components/Blocks/Poll';
import PollBlockEdit from 'volto-ministerio-publico-federal/components/Blocks/Poll/Edit';
import PollBlockView from 'volto-ministerio-publico-federal/components/Blocks/Poll/View';
import MpfPublicacoesEditaisBlockEdit from 'volto-ministerio-publico-federal/components/Blocks/PublicacoesEditais/Edit';
import MpfPublicacoesEditaisBlockView from 'volto-ministerio-publico-federal/components/Blocks/PublicacoesEditais/View';
import { PublicacoesEditaisBlockDataAdapter } from 'volto-ministerio-publico-federal/components/Blocks/PublicacoesEditais/adapter';

import { GROUP_HOME } from './groups';

/** Blocos da capa do portal. */
export const homeBlocks = {
  mpfDestaques: {
    id: 'mpfDestaques',
    title: 'Destaques (capa)',
    icon: imagesSVG,
    group: GROUP_HOME,
    view: MpfDestaquesBlockView,
    edit: MpfDestaquesBlockEdit,
    dataAdapter: DestaquesBlockDataAdapter,
    mostUsed: false,
    sidebarTab: 1,
  },
  mpfAcoesRapidas: {
    id: 'mpfAcoesRapidas',
    title: 'Ações rápidas (capa)',
    icon: listBulletSVG,
    group: GROUP_HOME,
    view: MpfAcoesRapidasBlockView,
    edit: MpfAcoesRapidasBlockEdit,
    dataAdapter: AcoesRapidasBlockDataAdapter,
    mostUsed: false,
    sidebarTab: 1,
  },
  mpfOndeAtua: {
    id: 'mpfOndeAtua',
    title: 'Onde o MPF atua? (capa)',
    icon: sliderSVG,
    group: GROUP_HOME,
    view: MpfOndeAtuaBlockView,
    edit: MpfOndeAtuaBlockEdit,
    dataAdapter: OndeAtuaBlockDataAdapter,
    mostUsed: false,
    sidebarTab: 1,
  },
  mpfIniciativas: {
    id: 'mpfIniciativas',
    title: 'Iniciativas e Projetos (capa)',
    icon: gridSVG,
    group: GROUP_HOME,
    view: MpfIniciativasBlockView,
    edit: MpfIniciativasBlockEdit,
    dataAdapter: IniciativasBlockDataAdapter,
    mostUsed: false,
    sidebarTab: 1,
  },
  mpfDestaquesCarrossel: {
    id: 'mpfDestaquesCarrossel',
    title: 'Destaques — carrossel (capa)',
    icon: sliderSVG,
    group: GROUP_HOME,
    view: MpfDestaquesCarrosselBlockView,
    edit: MpfDestaquesCarrosselBlockEdit,
    dataAdapter: DestaquesCarrosselBlockDataAdapter,
    mostUsed: false,
    sidebarTab: 1,
  },
  mpfPublicacoesEditais: {
    id: 'mpfPublicacoesEditais',
    title: 'Publicações e Editais (capa)',
    icon: folderSVG,
    group: GROUP_HOME,
    view: MpfPublicacoesEditaisBlockView,
    edit: MpfPublicacoesEditaisBlockEdit,
    dataAdapter: PublicacoesEditaisBlockDataAdapter,
    mostUsed: false,
    sidebarTab: 1,
  },
  mpfAcompanheRedes: {
    id: 'mpfAcompanheRedes',
    title: 'Acompanhe nossas redes (capa)',
    icon: shareSVG,
    group: GROUP_HOME,
    view: MpfAcompanheRedesBlockView,
    edit: MpfAcompanheRedesBlockEdit,
    // Com `blockSchema` o Form do Volto valida o bloco no save: barra o
    // salvamento, seleciona o bloco e aponta o post sem ALT na sidebar.
    blockSchema: mpfAcompanheRedesSchema,
    mostUsed: false,
    sidebarTab: 1,
  },
  homeBannerPortal: {
    id: 'homeBannerPortal',
    title: 'Home Banner',
    icon: homeBannerSVG,
    group: GROUP_HOME,
    view: HomeBannerBlockView,
    edit: HomeBannerBlockEdit,
    dataAdapter: HomeBannerBlockDataAdapter,
    mostUsed: false,
    sidebarTab: 1,
  },
  poll: {
    id: 'poll',
    title: 'Poll',
    icon: PollIcon,
    group: GROUP_HOME,
    view: PollBlockView,
    edit: PollBlockEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    blockHasOwnFocusManagement: true,
  },
};

export default homeBlocks;
